import { api } from "../client";
import {
  ProductExtraFields,
  ProductFields,
  PartialProductExtraFields,
  PartialProductFields,
} from "../schema/Product";
import { Config, ConfigMutate } from "../types";

type ApiRequestConfig = Config<ProductFields, ProductExtraFields>;
type ApiRequestConfigMutate = ConfigMutate<
  PartialProductFields,
  PartialProductExtraFields
>;

export const getProducts = async (config?: ApiRequestConfig) => {
  return api.get<ProductFields, ProductExtraFields>("products", config);
};
export const getProduct = (id: number, config?: ApiRequestConfig) => {
  return api.get<ProductFields, ProductExtraFields>(`products/${id}`, config);
};

export const createProduct = (config: ApiRequestConfigMutate) => {
  return api.create<PartialProductFields, PartialProductExtraFields>(
    "products",
    config
  );
};
export const updateProduct = (id: number, config?: ApiRequestConfigMutate) => {
  return api.update<PartialProductFields, PartialProductExtraFields>(
    `products/${id}`,
    config
  );
};
export const deleteProduct = (id: number) => {
  return api.remove<ProductFields, ProductExtraFields>(`products/${id}`);
};
